import React, { createContext, useContext } from 'react';
import { UserContext } from '../components/auth/auth';

interface ReadonlyContextType {
    readonly: boolean;
    setForceReadonly: (value: boolean) => void;
}

const ReadonlyContext = createContext<ReadonlyContextType>({
    readonly: true,
    setForceReadonly: () => { },
});

export { ReadonlyContext };

/**
 * Определяет режим READONLY на основе payed_till пользователя и принудительного флага.
 */
export function ReadonlyProvider({ children }: {
    children: React.ReactNode;
}) {
    const user = useContext(UserContext);
    const [forceReadonly, setForceReadonly] = React.useState(false);

    const readonly = forceReadonly || !user?.payed_till || new Date(user.payed_till) <= new Date();

    return (
        <ReadonlyContext.Provider value={{ readonly, setForceReadonly }}>
            {children}
        </ReadonlyContext.Provider>
    );
}

export function useReadonly(): ReadonlyContextType {
    return useContext(ReadonlyContext);
}

export default ReadonlyContext;
